import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import Breadcrumb from '@/components/ui/breadcrumb';
import Navigation from '@/components/ui/navigation';
import { navigationCourse } from '../constants';
import { LearnPage } from '@/graphql/generated/graphql';
import Container from '@/components/Container';
import Divider from '@/components/Divider';
import Button from '@/components/Button';
import DialogConfirmation from '@/components/confirmDialog/DialogConfirmation';
import { useFeedback } from './useFeedback';

export const FeedbackPage = () => {
  const {
    course,
    page,
    items,
    showLeaveDialog,
    setShowLeaveDialog,
    handleConfirmNavigation,
    handleNavigation,
    onSubmit,
    handleSubmit,
    errors,
    loading,
    register,
    pageData,
  } = useFeedback();

  return (
    <>
      <Navigation title="Learn" items={navigationCourse} />
      <AnimatedFadeInComponent>
        <Breadcrumb
          onNavigate={(path) => handleNavigation(path)}
          items={items.map((item) => ({
            ...item,
            onClick: item.url ? () => handleNavigation(item.url) : undefined,
          }))}
        />
      </AnimatedFadeInComponent>
      <Container className="default-content-template min-h-40">
        <div className="col-span-12 lg:col-start-3 lg:col-end-11">
          <div className="grid grid-cols-subgrid gap-sh-30">
            <div className="flex flex-col gap-sh-30">
              <AnimatedFadeInComponent>
                <p className="font-larken text-sh-30-38">{course?.attributes?.title}</p>
                <p className="font-larken text-sh-36-48">{page?.title}</p>
                <p className=" text-sh-sm">{page?.description}</p>
                <Divider />

                <h3 className=" font-larken text-sh-md">{page?.submitYourFeedback}</h3>

                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
                  {course?.attributes?.feedbackQuestions?.map((feedbackQuestion, index) => (
                    <div key={feedbackQuestion?.question} className="flex flex-col gap-2">
                      <p className=" text-sh-xxs">Question {index + 1}</p>
                      <label className="text-sh-sm font-medium">{feedbackQuestion?.question}</label>
                      <input
                        type="hidden"
                        {...register(`answers.${index}.question`)}
                        value={feedbackQuestion?.question || ''}
                      />
                      <textarea
                        {...register(`answers.${index}.answer`)}
                        className="min-h-[100px] w-full rounded-md border p-3"
                        placeholder={page?.enterYourFeedback}
                      />
                      {errors.answers?.[index]?.answer && (
                        <span className="text-sm text-red-500">{errors.answers[index]?.answer?.message}</span>
                      )}
                    </div>
                  ))}
                  <div>
                    <Button loading={loading} type="submit">
                      {page?.sendFeedback}
                    </Button>
                  </div>
                </form>
              </AnimatedFadeInComponent>
            </div>
          </div>
        </div>
      </Container>

      <DialogConfirmation
        open={showLeaveDialog}
        setOpen={setShowLeaveDialog}
        onConfirm={handleConfirmNavigation}
        onCancel={() => setShowLeaveDialog(false)}
        learnPage={pageData?.learnPage?.data?.attributes as LearnPage}
      />
    </>
  );
};
